export const generalSettingsCheckboxes = ({ storageKeys, store }) => [
  {
    checkedValue: store.shouldDeleteOnBlockChange,
    text: 'Delete and Restart Logging Upon Each Block Change',
    value: true,
    onClick: () =>
      store.setDebugItem(
        storageKeys.deleteOnBlockChange,
        !store.shouldDeleteOnBlockChange,
      ),
  },
  {
    checkedValue: store.shouldWriteLogToDevWindow,
    text: 'Write Messages to this Dev Window',
    value: true,
    onClick: () =>
      store.setDebugItem(
        storageKeys.writeLogToDevWindow,
        !store.shouldWriteLogToDevWindow,
      ),
  },
  {
    checkedValue: store.shouldReadLogWhenConnected,
    text: 'Allow Showing Dev Window When Connected with No Errors',
    value: true,
    onClick: () =>
      store.setDebugItem(
        storageKeys.readLogWhenConnected,
        !store.shouldReadLogWhenConnected,
      ),
  },
  {
    checkedValue: store.shouldWriteLogWhenConnected,
    text: 'Allow Writing Info Messages to Log When Connected with No Errors',
    value: true,
    onClick: () => {
      store.setDebugItem(
        storageKeys.writeToLogWhenConnected,
        !store.shouldWriteLogWhenConnected,
      );

      if (
        store.uiLogLevel !== 'verbose' &&
        (store.shouldWriteLogWhenConnected ||
          !store.shouldWriteTimstampsToConsole)
      ) {
        store.setDebugItem(storageKeys.uiLogLevel, 'verbose');
        return;
      }

      if (
        store.uiLogLevel !== 'errors' &&
        store.shouldWriteLogWhenConnected &&
        !store.shouldWriteTimstampsToConsole
      ) {
        store.setDebugItem(storageKeys.uiLogLevel, 'errors');
      }
    },
  },
  {
    checkedValue: store.shouldSendTimestampsToEngine,
    text: 'Enable Timestamps to be Sent to Engine',
    value: true,
    onClick: () => {
      store.setDebugItem(
        storageKeys.sendTimestampsToEngine,
        !store.shouldSendTimestampsToEngine,
      );
      store.setDebugItem(
        storageKeys.engineLogLevel,
        !store.shouldSendTimestampsToEngine ? 'verbose' : 'off',
      );
    },
  },
  {
    checkedValue: store.shouldWriteTimstampsToConsole,
    text: 'Enable Send/Receive Timestamps to Write to Console Window',
    value: true,
    onClick: () => {
      store.setDebugItem(
        storageKeys.writeTimestampsToConsole,
        !store.shouldWriteTimstampsToConsole,
      );

      if (
        store.uiLogLevel !== 'verbose' &&
        (store.shouldWriteLogWhenConnected ||
          !store.shouldWriteTimstampsToConsole)
      ) {
        store.setDebugItem(storageKeys.uiLogLevel, 'verbose');
        return;
      }

      if (
        store.uiLogLevel !== 'errors' &&
        !store.shouldWriteLogWhenConnected &&
        store.shouldWriteTimstampsToConsole
      ) {
        store.setDebugItem(storageKeys.uiLogLevel, 'errors');
      }
    },
  },
  {
    checkedValue: store.shouldWriteLogToConsole,
    text: 'Enable Message Log to Write to Console Window',
    value: true,
    onClick: () =>
      store.setDebugItem(
        storageKeys.writeLogToConsole,
        !store.shouldWriteLogToConsole,
      ),
  },
  {
    checkedValue: store.shouldSkipPingPongWhenConnected,
    text: 'Skip Logging Ping/Pong (Noisy chatter every few seconds)',
    value: true,
    onClick: () =>
      store.setDebugItem(
        storageKeys.skipPingPongWhenConnected,
        !store.shouldSkipPingPongWhenConnected,
      ),
  },
];

export const uiLogLevelCheckboxes = ({ storageKeys, store }) => [
  {
    checkedValue: store.uiLogLevel,
    group: 'uiLogLevel',
    text: 'OFF',
    value: 'off',
    onClick: () => store.setDebugItem(storageKeys.uiLogLevel, 'off'),
  },
  {
    checkedValue: store.uiLogLevel,
    group: 'uiLogLevel',
    text: 'ERRORS',
    value: 'errors',
    onClick: () => store.setDebugItem(storageKeys.uiLogLevel, 'errors'),
  },
  {
    checkedValue: store.uiLogLevel,
    group: 'uiLogLevel',
    text: 'VERBOSE',
    value: 'verbose',
    onClick: () => store.setDebugItem(storageKeys.uiLogLevel, 'verbose'),
  },
];

export const engineLogLevelCheckboxes = ({ storageKeys, store }) => [
  {
    checkedValue: store.engineLogLevel,
    group: 'engineLogLevel',
    text: 'OFF',
    value: 'off',
    onClick: () => store.setDebugItem(storageKeys.engineLogLevel, 'off'),
  },
  {
    checkedValue: store.engineLogLevel,
    group: 'engineLogLevel',
    text: 'ERRORS',
    value: 'errors',
    onClick: () => store.setDebugItem(storageKeys.engineLogLevel, 'errors'),
  },
  {
    checkedValue: store.engineLogLevel,
    group: 'engineLogLevel',
    text: 'VERBOSE',
    value: 'verbose',
    onClick: () => store.setDebugItem(storageKeys.engineLogLevel, 'verbose'),
  },
];
